import { Injectable } from '@angular/core';

@Injectable()

export class DownloadFileService {
    downloadFile(data, filename) {
        let csvData = this.ConvertToCSV(data, ['accommodationId', 'friendlyName', 'addressLine1', 'addressLine2', 'town', 'countryId', 'postcode']);

        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let downloadLink = document.createElement("a");
        let url = URL.createObjectURL(blob);

        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  
            downloadLink.setAttribute("target", "_blank");
        }

        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", filename + ".csv");
        downloadLink.style.visibility = "hidden";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }sni

    ConvertToCSV(objArray, headerList) {
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;

        // to avoid mutation on original 
        let newArray = [];

        array.forEach(x => {
            let listing = JSON.parse(JSON.stringify(x)); 
            listing.friendlyName = listing.friendlyName ? listing.friendlyName.replace(listing.friendlyName, `"${listing.friendlyName}"`) : '';
            listing.addressLine1 = listing.addressLine1.replace(listing.addressLine1, `"${listing.addressLine1}"`);
            listing.addressLine2 = listing.addressLine2 ? listing.addressLine2.replace(listing.addressLine2, `"${listing.addressLine2}"`) : '';
            listing.town = listing.town.replace(listing.town, `"${listing.town}"`);
            listing.postcode = listing.postcode.replace(listing.postcode, `"${listing.postcode}"`);
            newArray.push(listing);
        });

        let str = '';
        let row = 'L.No,';

        for (let index in headerList) {
            row += headerList[index] + ',';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';

        for (let i = 0; i < newArray.length; i++) {
            let line = (i + 1) + '';

            for (let index in headerList) {
                let head = headerList[index];
                line += ',' + newArray[i][head];
            }
            str += line + '\r\n';
        }
        return str;
    }
}